import { useMemo as c } from "react";
import { apiClient as f } from "../provider/create-provider.js";
import { createFieldMapper as m } from "../utils/directus-field-mapper.js";
import { useLocalizedQueryParams as p } from "./use-localized-query-params.js";
const { map: y, fields: P } = m()({
  _all: !0,
  translations: {
    _all: !0
  }
});
function M(r) {
  const t = "translations", { filters: i, deepFilters: s } = p({
    filterByLocalizedSlug: !0,
    filtersPath: t
  }), { isLoading: o, isError: l, isPending: n, isPaused: a, isSuccess: u, error: d, data: e } = f.items.readItemsTranslations.useQuery(
    {
      query: {
        fields: P,
        filter: [i],
        limit: -1,
        deep: s
      }
    },
    { enabled: !(r != null && r.pause) }
  );
  return {
    isLoading: o,
    isError: l,
    isPending: n,
    isPaused: a,
    isSuccess: u,
    error: d,
    data: c(() => y(e == null ? void 0 : e.data), [e == null ? void 0 : e.data])
  };
}
export {
  M as useTranslations
};
